// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ProductCategories_RemoverResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /so/product_categories/remover
 *
 * Returns null dados on success.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type ProductCategories_RemoverResponseDados = null;

export type ProductCategories_RemoverResponse = ApiResponse<ProductCategories_RemoverResponseDados>;

registerResponseContract('ProductCategories_RemoverResponse', {})
